export var TenantType;
(function (TenantType) {
    TenantType["EPIC"] = "EPIC";
    TenantType["ATHENA"] = "ATHENA";
    TenantType["CERNER"] = "CERNER";
    TenantType["MOCK"] = "MOCK";
})(TenantType || (TenantType = {}));
